export default __webpack_public_path__ + "static/media/separation-white.8bbeead5.svg";